import React from 'react';
import Segment from '@cp/pages/Paramount/Documentation/Segment';
import Strategy from '@cp/pages/Paramount/Documentation/Strategy';
import Trigger from '@cp/pages/Paramount/Documentation/Trigger';
import Playground from '@cp/pages/Paramount/Documentation/Playground';

type DocumentationProps = {
  entity: string;
};
function Documentation({ entity }: DocumentationProps) {
  if (entity === 'segment') {
    return <Segment />;
  }
  if (entity === 'strategy') {
    return <Strategy />;
  }
  if (entity === 'trigger') {
    return <Trigger />;
  }
  return <Playground />;
}

export default Documentation;
